<template>
  <el-form :model="form" size="small" :rules="rules" ref="form" class="form-horizontal flex-column prepend-equal dicts-create-form">
    <div class="flex-row flex-wrap justify-content-between form-row">
      <!--<el-form-item prop="provinceCode">
        <div class="select-group">
          <span class="el-input-group__prepend select-prepend">省份</span>
          <el-select clearable v-model="form.provinceCode" filterable placeholder="——省份——">
            <el-option v-for="item in provinces" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="cityCode">
        <div class="select-group">
          <span class="el-input-group__prepend select-prepend">城市</span>
          <el-select clearable v-model="form.cityCode" filterable  placeholder="——城市——">
            <el-option v-for="item in cities" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
            </el-option>
          </el-select>
        </div>
      </el-form-item>-->
      <el-form-item v-if="formType === '新增'" class="pAreaCodeElement" prop="pAreaCode" label="所属区域" label-width="90px" >

        <el-cascader ref="locationCascader" placeholder="所属区域" :props="policeStateProps" v-model="form.parentAreaCode" clearable @change="caderChange">
        </el-cascader>
      </el-form-item>
      <el-form-item prop="areaCode" class="required">
        <el-input placeholder="不许重复" v-model.trim="form.areaCode" :disabled=" formType != '新增'">
          <template slot="prepend">地区编码</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="areaName" class="required">
        <el-input placeholder="" v-model.trim="form.areaName" >
          <template slot="prepend">区域名称</template>
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="boundary" class="flex-1">
        <el-input placeholder="" v-model="form.boundary" >
          <template slot="prepend">边界</template>
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between form-row">

      <el-form-item prop="xpoint">
        <el-input placeholder="" v-model="form.xpoint">
          <template slot="prepend">经度</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="ypoint">
        <el-input placeholder="" v-model="form.ypoint">
          <template slot="prepend">纬度</template>
        </el-input>
      </el-form-item>
    </div>
    <div class="flex-row flex-wrap justify-content-between form-row">
      <el-form-item prop="use_status">
        <div class="flex-row" style="width: 100%;">
          <span class="el-input-group__prepend label-prepend m-r-sm">是否可用</span>
          <el-radio-group v-model="form.use_status">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </div>
    <div class="text-center p-t-sm">
      <!-- <button class="btn btn-primary btn-save" type="button" @click="submitForm" v-loading="submitLoading">确定</button> -->
      <el-button class="primary-btn-g" icon="CircleCheck" @click="submitForm" v-loading="submitLoading" >确定</el-button>
      <!-- <button class="btn btn-white btn-cancle" data-dismiss="modal">取消</button> -->
      <el-button class="warning-btn-g" icon="CircleClose" data-dismiss="modal">取消</el-button>
    </div>
  </el-form>
</template>
<script>
import {
  mapActions
}
from 'vuex'
export default {
  name: 'dictAreaForm',
  props: {
    formType: {
      type: String,
      default: ''
    },
    region: {
      type: Object,
      default: null,
    },
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provinces: [],
      cities: [],
      submitLoading: false,

      form: {
        provinceCode: '',
        cityCode: '',
        pAreaCode: '',
        parentAreaCode: '',
        areaCode: '',
        areaName: '',
        boundary: '',
        xpoint: '',
        ypoint: '',
        use_status: '1'
      },
      rules: {
        areaCode: [{
          required: true,
          message: '请输入地区编码',
          trigger: 'blur'
        },],
        areaName: [{
          required: true,
          message: '请输入地区名称',
          trigger: 'blur'
        }]
      },
      policeStateProps: {
        emitPath: false,
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.getStateNext,
      },
    }
  },
  created() {
    let params = {
      areaCode: 0
    }
    let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
    this._fetchBasicalData(url, params, 'provinces')
  },
  watch: {
    modalShow(to) {
      this.$refs.form.resetFields()
      if(this.region !== null){
        this.form = {
          ...this.form,
          ...this.region,
          parentAreaCode:this.region.pAreaCode
        }
        console.log(this.form.parentAreaCode,this.region)
        setTimeout(() => {
          this.form.cityCode = this.region.cityCode || ''
        }, 10)
      }
    },

    'form.provinceCode': function(to) {
      this.form.cityCode = ''
      this.form.pAreaCode = to
      let params = {
        areaCode: to
      }
      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'
      this._fetchBasicalData(url, params, 'cities')
    },
    'form.cityCode': function(to) {
      if(to !== ''){
        this.form.pAreaCode = to
      }
    },
  },
  mounted() {
    if (this.region !== null) {
      this.form = {
        ...this.form,
        ...this.region,
        parentAreaCode:this.region.pAreaCode
      }

      setTimeout(() => {
        this.form.cityCode = this.region.cityCode || ''
      }, 10)
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    _fetchBasicalData(url, params, type) {
      const _this = this
      this.fetchData({url, method: 'get', params}).then(res => {
        this[type] = res.data
      }).catch(err => {
        this.error = err
      })
    },
    // 省市区,树形结构
    getStateNext(node, resolve) {
      if(node.level==4){
        resolve([])
      }
      let code = node.level == 0 ? 0 : node.value

      let url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE'

      let params = {
        areaCode: code,
      }
      this.fetchData({
        url,
        method: 'get',
        params,
      })
        .then((res) => {
          let tempArr = []
          res.data.forEach((re) => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                leaf: node && node.level == 3 ? true : false,
              })
            }
            if (re.name) {
              tempArr.push({
                value: re.policeCode,
                label: re.name,
                leaf: node && node.level == 3 ? true : false,
              })
            }
          })
          resolve(tempArr)
        })
    },
    submitForm() {
      const _this = this;

      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = this.formType === '新增' ?
            'DICT.AREA_INFO_ADD' :
            'DICT.AREA_INFO_UPDATE';


          let region = {
            ...this.form,
            pAreaCode: this.form.parentAreaCode?this.form.parentAreaCode:'0'
          }

          let params = {
            areaInfo: JSON.stringify(region)
          }


          this.submitLoading = true
          this.fetchData({
            url,
            method: 'post',
            params,
            timeout:0,
            isLoading:false,
            flag:true
          }).then(res => {
            if(res && res.status==1){
              _this.alertToggle({
                alertType: 'success',
                alertContent: res.msg || '操作成功'
              })
              _this._finishOperate()
            }else{
              let tipMsg = (res&&res.msg) ? res.msg:'操作失败'
              _this.alertToggle({
                alertType: 'danger',
                alertContent: tipMsg
              })
              this.submitLoading = false
            }

          }).catch(err => {
            _this.submitLoading = false
            if(err.indexOf('编码') > -1){
              let field = _this.$refs.form.fields.filter(field => field.prop === 'areaCode')[0];
              field.validateMessage = err
              field.validateState = 'error'
            }
            return false
          })
        }else{
          return false;
        }
      });
    },
    _finishOperate() {
      this.submitLoading = false
      this.$emit('success', { province: this.form.provinceCode, city: this.form.cityCode })
    },
    //级联选中
    caderChange(){
      this.$refs.locationCascader.dropDownVisible = false
    },
  }

}
</script>
<style lang="less">
  .prepend-equal .pAreaCodeElement{
    width: 100% !important;
    display: flex;
  }
  .prepend-equal .pAreaCodeElement /deep/.el-form-item__content{
    margin-left: 0px !important;
    flex:1 !important;
  }
</style>
